export default __webpack_public_path__ + "static/media/480_business05-es-web.5fe89725.png";